module.exports = __webpack_public_path__ + "img/cloud-moon.d894de87.svg";